var map = {
	"./AffiliatePlans/List.vue": [
		"d560",
		"chunk-032349eb",
		"chunk-7fd5416c"
	],
	"./AffiliatePlans/NewOrEdit.vue": [
		"c188",
		"chunk-4e7b4309"
	],
	"./Auth/Login.vue": [
		"d60c",
		"chunk-ed79b4d4"
	],
	"./Auth/Logout.vue": [
		"4217",
		"chunk-ed8934bc"
	],
	"./Auth/NewPassword.vue": [
		"3ed8",
		"chunk-3874217f"
	],
	"./Auth/Register.vue": [
		"3232",
		"chunk-635f7d66"
	],
	"./Auth/ResetPassword.vue": [
		"8503",
		"chunk-70bbd44f"
	],
	"./Auth/VerifyEmail.vue": [
		"462f",
		"chunk-29149350"
	],
	"./Auth/partial/CloudFrontVerification.vue": [
		"5a5e",
		"chunk-2d0d2b92"
	],
	"./Auth/partial/EmailHints.vue": [
		"1e3a",
		"chunk-7d57f35a"
	],
	"./Dashboard/View.vue": [
		"1407",
		"chunk-5fe1576a",
		"chunk-5b0846f3",
		"chunk-4f547e3b",
		"chunk-64b25c52",
		"chunk-4d1b021e"
	],
	"./Gateways/List.vue": [
		"3b39",
		"chunk-032349eb",
		"chunk-c3ec3b52"
	],
	"./Gateways/NewOrEdit.vue": [
		"5451",
		"chunk-04fd0674"
	],
	"./Gateways/Process.vue": [
		"c0d7"
	],
	"./Gateways/partial/CPay.vue": [
		"84fc",
		"chunk-4fc2d642"
	],
	"./Gateways/partial/Gateway.vue": [
		"0120"
	],
	"./Gateways/partial/Gateways.vue": [
		"25ba"
	],
	"./Gateways/partial/Step4.vue": [
		"201d"
	],
	"./Invoices/CreateInvoiceDialog.vue": [
		"07a5",
		"chunk-08c8e3e8"
	],
	"./Invoices/List.vue": [
		"c7d7",
		"chunk-032349eb",
		"chunk-08c8e3e8",
		"chunk-53226fd5"
	],
	"./Invoices/PayInvoiceDialog.vue": [
		"dc31",
		"chunk-19e44060"
	],
	"./Invoices/RefundInvoiceDialog.vue": [
		"da94",
		"chunk-0a8e117f"
	],
	"./Invoices/View.vue": [
		"d78b",
		"chunk-352df9cc"
	],
	"./Modules/BulkPayouts/List.vue": [
		"1698",
		"chunk-032349eb",
		"chunk-ae0baa22"
	],
	"./Modules/BulkPayouts/partial/UploadFileDialog.vue": [
		"b7c0",
		"chunk-02662886"
	],
	"./Modules/Cms/List.vue": [
		"dc3c",
		"chunk-032349eb",
		"chunk-2d0d6793",
		"chunk-1bcf9d80",
		"chunk-5dab3afc"
	],
	"./Modules/Cms/NewOrEditForm.vue": [
		"b8a7",
		"chunk-2d0d6793",
		"chunk-1bcf9d80"
	],
	"./Modules/Cms/patrial/SelectIconsDialog.vue": [
		"7367",
		"chunk-2d0d6793"
	],
	"./Modules/Configuration/List.vue": [
		"d8f9",
		"chunk-032349eb",
		"chunk-b39baccc"
	],
	"./Modules/Configuration/NewOrEdit.vue": [
		"a474",
		"chunk-fd936172"
	],
	"./Modules/Deals/List.vue": [
		"f9e7",
		"chunk-032349eb",
		"chunk-ed14057e",
		"chunk-5431e692"
	],
	"./Modules/Deals/partial/NewOrEdit.vue": [
		"2acb",
		"chunk-ed14057e"
	],
	"./Modules/Deals/partial/dealStatus.vue": [
		"f387",
		"chunk-2d22c542"
	],
	"./Modules/Deals/partial/viewMode.vue": [
		"a318",
		"chunk-58d7ca76"
	],
	"./Modules/Investments/List.vue": [
		"9a03",
		"chunk-032349eb",
		"chunk-7c9d11d2",
		"chunk-f83dfe3a"
	],
	"./Modules/Investments/NewOrEdit.vue": [
		"8149",
		"chunk-7c9d11d2"
	],
	"./Modules/Ito/List.vue": [
		"4e50",
		"chunk-032349eb",
		"chunk-5fe1576a",
		"chunk-76b6b0a6",
		"chunk-09aaaea3",
		"chunk-fbe5ccdc"
	],
	"./Modules/Ito/NewOrEditForm.vue": [
		"3d1e",
		"chunk-5fe1576a",
		"chunk-76b6b0a6",
		"chunk-09aaaea3",
		"chunk-2d21445b"
	],
	"./Modules/Ito/patrial/EditCurrentPrice.vue": [
		"7df9",
		"chunk-f1a935b2"
	],
	"./Modules/Ito/patrial/ProductsITO.vue": [
		"9611",
		"chunk-2d0e5af3"
	],
	"./Modules/Licenses/List.vue": [
		"fb85",
		"chunk-032349eb",
		"chunk-2ead9dce",
		"chunk-248aa49c"
	],
	"./Modules/Licenses/partial/EditRequestStatus.vue": [
		"5a3d",
		"chunk-2ead9dce"
	],
	"./Modules/Licenses/partial/LicenseView.vue": [
		"f0fc",
		"chunk-032349eb",
		"chunk-2ead9dce",
		"chunk-6f698024"
	],
	"./Modules/Licenses/partial/Purchase.vue": [
		"4156",
		"chunk-39b71c97"
	],
	"./Modules/Licenses/partial/RequestsView.vue": [
		"56a6",
		"chunk-032349eb",
		"chunk-2ead9dce",
		"chunk-4603a128"
	],
	"./Modules/Lms/List.vue": [
		"a0d9",
		"chunk-032349eb",
		"chunk-5b0846f3",
		"chunk-b3269ade",
		"chunk-e3ef20d4",
		"chunk-18ce6071"
	],
	"./Modules/Lms/NewOrEditForm.vue": [
		"3ba7",
		"chunk-032349eb",
		"chunk-5b0846f3",
		"chunk-b3269ade",
		"chunk-e3ef20d4",
		"chunk-70fa7208"
	],
	"./Modules/Lms/partial/CourseLabelForm.vue": [
		"c029",
		"chunk-e3ef20d4",
		"chunk-2d21445b"
	],
	"./Modules/Lms/partial/FilesLabel/List.vue": [
		"a28d",
		"chunk-032349eb",
		"chunk-42ea848a"
	],
	"./Modules/Lms/partial/FilesLabel/partial/NewOrEditFile.vue": [
		"20f9",
		"chunk-efd0402e"
	],
	"./Modules/Lms/partial/LecturesLabel/List.vue": [
		"4bb4",
		"chunk-032349eb",
		"chunk-b3269ade",
		"chunk-59df5caf"
	],
	"./Modules/Lms/partial/LecturesLabel/partial/NewOrEditLecture.vue": [
		"bfa1",
		"chunk-b3269ade"
	],
	"./Modules/Lms/partial/LecturesLabel/partial/NewOrEditSection.vue": [
		"fa74",
		"chunk-1c0c3b08"
	],
	"./Modules/Products/Dashboard/View.vue": [
		"b040",
		"chunk-0c717a70"
	],
	"./Modules/Products/Dashboard/partial/Overview.vue": [
		"159a",
		"chunk-3fb70cfe"
	],
	"./Modules/Products/Dashboard/partial/StatsTable.vue": [
		"951c",
		"chunk-463c30c2"
	],
	"./Modules/Products/List.vue": [
		"559f",
		"chunk-032349eb",
		"chunk-476b3d42",
		"chunk-351fbc5a",
		"chunk-74bfce9a"
	],
	"./Modules/Products/NewOrEdit.vue": [
		"24d2",
		"chunk-032349eb",
		"chunk-476b3d42",
		"chunk-351fbc5a"
	],
	"./Modules/Products/partial/CheckoutLinkDialog.vue": [
		"1612",
		"chunk-707778bf"
	],
	"./Modules/Products/partial/EditCategoriesDialog.vue": [
		"5e4f",
		"chunk-032349eb",
		"chunk-476b3d42"
	],
	"./Modules/Products/partial/UpgradableProducts.vue": [
		"3231",
		"chunk-2d0b91f3"
	],
	"./Modules/PromoCodes/List.vue": [
		"0140",
		"chunk-032349eb",
		"chunk-78f69ff7",
		"chunk-4450f167"
	],
	"./Modules/PromoCodes/NewOrEdit.vue": [
		"1d1f",
		"chunk-78f69ff7"
	],
	"./Modules/RoadMap/List.vue": [
		"c42f",
		"chunk-032349eb",
		"chunk-5fe1576a",
		"chunk-0645d2a3",
		"chunk-7c6fe8f8",
		"chunk-37932146"
	],
	"./Modules/RoadMap/NewOrEdit.vue": [
		"8c26",
		"chunk-032349eb",
		"chunk-5fe1576a",
		"chunk-0645d2a3",
		"chunk-7c6fe8f8"
	],
	"./Modules/RoadMap/partial/EditStageDialog.vue": [
		"501f",
		"chunk-032349eb",
		"chunk-0645d2a3"
	],
	"./Modules/SpotFutures/Connections/View.vue": [
		"ca8d",
		"chunk-032349eb",
		"chunk-5fe1576a",
		"chunk-5b0846f3",
		"chunk-717cc324",
		"chunk-737e6d72"
	],
	"./Modules/SpotFutures/Connections/partial/BalanceHistory.vue": [
		"ffa8",
		"chunk-032349eb",
		"chunk-5fe1576a",
		"chunk-512475a3"
	],
	"./Modules/SpotFutures/Connections/partial/DisconnectDialog.vue": [
		"3693",
		"chunk-34d644c1"
	],
	"./Modules/SpotFutures/Connections/partial/TraderView.vue": [
		"f52d",
		"chunk-717cc324"
	],
	"./Modules/SpotFutures/Connections/partial/ViewKeySecretDialog.vue": [
		"fc35",
		"chunk-075e8942"
	],
	"./Modules/SpotFutures/Dashboard/View.vue": [
		"6517",
		"chunk-5fe1576a",
		"chunk-4f547e3b",
		"chunk-64b25c52",
		"chunk-b69630b0"
	],
	"./Modules/SpotFutures/Dashboard/partial/AumPie.vue": [
		"e93d",
		"chunk-4f547e3b",
		"chunk-64b25c52"
	],
	"./Modules/SpotFutures/Dashboard/partial/Overview.vue": [
		"e5cd",
		"chunk-d61380a4"
	],
	"./Modules/SpotFutures/Dashboard/partial/StatsTable.vue": [
		"93a2",
		"chunk-7bdda2f6"
	],
	"./Modules/SpotFutures/Dashboard/partial/StrategyStats.vue": [
		"c4e8",
		"chunk-5fe1576a",
		"chunk-15f84e43"
	],
	"./Modules/SpotFutures/LinkedAccounts/List.vue": [
		"033c",
		"chunk-032349eb",
		"chunk-7cedc332"
	],
	"./Modules/SpotFutures/Strategies/List.vue": [
		"1119",
		"chunk-032349eb",
		"chunk-5fe1576a",
		"chunk-f7a4d37a"
	],
	"./Modules/SpotFutures/Strategies/NewOrEdit.vue": [
		"af83",
		"chunk-185a5d0e",
		"chunk-5b0846f3",
		"chunk-8cb87468",
		"chunk-00f495fc"
	],
	"./Modules/SpotFutures/Strategies/View.vue": [
		"bfb4",
		"chunk-5fe1576a",
		"chunk-5b0846f3",
		"chunk-4f547e3b",
		"chunk-25ff8c1b",
		"chunk-64fe7c7e"
	],
	"./Modules/SpotFutures/Strategies/partial/FeeStructure.vue": [
		"c867",
		"chunk-2d217aac"
	],
	"./Modules/SpotFutures/Strategies/partial/FormDataRoom.vue": [
		"7658",
		"chunk-8cb87468"
	],
	"./Modules/SpotFutures/Strategies/partial/FormDetails.vue": [
		"7281",
		"chunk-3990ccc7"
	],
	"./Modules/SpotFutures/Strategies/partial/FormProfile.vue": [
		"e7b9",
		"chunk-185a5d0e",
		"chunk-f84550f6"
	],
	"./Modules/SpotFutures/Strategies/partial/MoveStrategyDialog.vue": [
		"91a2",
		"chunk-2d324b3c"
	],
	"./Modules/SpotFutures/Strategies/partial/PnLSmallChart.vue": [
		"62ff",
		"chunk-14c43012"
	],
	"./Modules/SpotFutures/Strategies/partial/TraderBalanceChart.vue": [
		"b603",
		"chunk-5fe1576a",
		"chunk-4f547e3b",
		"chunk-d384febc"
	],
	"./Modules/SpotFutures/Strategies/partial/TraderPerformance.vue": [
		"110d",
		"chunk-4f547e3b",
		"chunk-010b0dd6"
	],
	"./Modules/SpotFutures/Strategies/partial/TraderResult.vue": [
		"e594",
		"chunk-25ff8c1b",
		"chunk-2d20862b"
	],
	"./Modules/Staking/List.vue": [
		"a877",
		"chunk-032349eb",
		"chunk-76b6b0a6",
		"chunk-171b5e89"
	],
	"./Modules/Staking/NewOrEdit.vue": [
		"469d",
		"chunk-76b6b0a6",
		"chunk-1cb9ec8d"
	],
	"./Modules/Staking/UserDetails.vue": [
		"47e8",
		"chunk-51172604"
	],
	"./MyInvoices/List.vue": [
		"206f",
		"chunk-032349eb",
		"chunk-c10d2280"
	],
	"./MyInvoices/ThankYou.vue": [
		"b87c",
		"chunk-57f6c69c"
	],
	"./MyInvoices/View.vue": [
		"2c30",
		"chunk-e24a0f30"
	],
	"./Profile/Profile.vue": [
		"8f06",
		"chunk-49a04b85"
	],
	"./Security/View.vue": [
		"f767",
		"chunk-55f717f5",
		"chunk-c8c94066"
	],
	"./Security/partial/DeactivateTwoFaDialog.vue": [
		"b449",
		"chunk-bcad5d80"
	],
	"./Security/partial/EmailVerificationCode.vue": [
		"d051",
		"chunk-a84282f4"
	],
	"./Security/partial/LoginHistoryView.vue": [
		"cb5d",
		"chunk-5cef330d"
	],
	"./Security/partial/TwoFaDialog.vue": [
		"d8f4",
		"chunk-55f717f5"
	],
	"./Security/partial/TwoFaVerification.vue": [
		"8fe3",
		"chunk-9058d176"
	],
	"./Security/partial/TwoFaView.vue": [
		"48b1",
		"chunk-55f717f5",
		"chunk-b066e330"
	],
	"./Transactions/List.vue": [
		"b636",
		"chunk-032349eb",
		"chunk-fa398562"
	],
	"./Users/List.vue": [
		"ac1e",
		"chunk-032349eb",
		"chunk-5fe1576a",
		"chunk-0f09bf0e",
		"chunk-1edd1574",
		"chunk-6efc30ac"
	],
	"./Users/partial/BalanceEditDialog.vue": [
		"d438",
		"chunk-1c1b79cc"
	],
	"./Users/partial/ChangeReferrerDialog.vue": [
		"97cb",
		"chunk-1edd1574"
	],
	"./Users/partial/DeleteDialog.vue": [
		"8701e",
		"chunk-8896b98a"
	],
	"./Users/partial/Details.vue": [
		"9bba",
		"chunk-032349eb",
		"chunk-0f09bf0e"
	],
	"./Users/partial/EditDialog.vue": [
		"2649",
		"chunk-bb3323e4"
	],
	"./Users/partial/Purchase.vue": [
		"ec21",
		"chunk-97a8c5e0"
	],
	"./Users/partial/Referrals.vue": [
		"d8ce",
		"chunk-9e0f36b2"
	],
	"./Users/partial/Sponsor.vue": [
		"09d1",
		"chunk-e21c14c6"
	],
	"./Users/partial/TrialPeriodDialog.vue": [
		"0ccf",
		"chunk-5fe1576a",
		"chunk-96e9c5f2"
	],
	"./WhiteLabel/List.vue": [
		"cba3",
		"chunk-032349eb",
		"chunk-3e99b606"
	],
	"./WhiteLabel/NewOrEdit.vue": [
		"03d5",
		"chunk-185a5d0e",
		"chunk-5b0846f3",
		"chunk-f7782d6c",
		"chunk-1ff94e50",
		"chunk-5b56a3c5"
	],
	"./WhiteLabel/partial/WhiteLabelDesign.vue": [
		"19e9",
		"chunk-185a5d0e",
		"chunk-1ff94e50",
		"chunk-52d3a61c"
	],
	"./WhiteLabel/partial/WhiteLabelDesignDark.vue": [
		"e0bc",
		"chunk-185a5d0e",
		"chunk-c6a3130e"
	],
	"./WhiteLabel/partial/WhiteLabelDesignLight.vue": [
		"b330",
		"chunk-185a5d0e",
		"chunk-e118add6"
	],
	"./WhiteLabel/partial/WhiteLabelMarketing.vue": [
		"8f08",
		"chunk-7e4f30fa"
	],
	"./WhiteLabel/partial/WhiteLabelMockup.vue": [
		"40b2",
		"chunk-75d5b75c"
	],
	"./WhiteLabel/partial/WhiteLabelModules.vue": [
		"3612",
		"chunk-e7f353d6"
	],
	"./WhiteLabel/partial/WhiteLabelPaymentGateways.vue": [
		"0bc3",
		"chunk-8810fc6c"
	],
	"./WhiteLabel/partial/WhiteLabelProfile.vue": [
		"5698",
		"chunk-f7782d6c"
	],
	"./WhiteLabel/partial/WhiteLabelSetting.vue": [
		"0d8f",
		"chunk-2d0af158"
	],
	"./WhiteLabel/partial/WhiteLabelSubscription.vue": [
		"e4ab",
		"chunk-22c17106"
	],
	"./WhiteLabel/partial/WhiteLabelSupport.vue": [
		"9180",
		"chunk-6d09a169"
	],
	"./WhiteLabel/partial/WhiteLabelTheme.vue": [
		"d41f",
		"chunk-185a5d0e",
		"chunk-3b5ca623"
	],
	"./WhiteLabel/partial/svgMockDark.vue": [
		"7a25",
		"chunk-2d0e13c3"
	],
	"./WhiteLabel/partial/svgMockDarkEng.vue": [
		"8434",
		"chunk-2d0ddf53"
	],
	"./WhiteLabel/partial/svgMockLight.vue": [
		"d75c",
		"chunk-2d21eb57"
	],
	"./WhiteLabel/partial/svgMockLightEng.vue": [
		"810f",
		"chunk-2d0dd3e5"
	],
	"./Withdrawals/AutomatedPayoutDialog.vue": [
		"897e",
		"chunk-3d58c8b7"
	],
	"./Withdrawals/AutomationDialog.vue": [
		"e3f1",
		"chunk-3bb6ca05"
	],
	"./Withdrawals/List.vue": [
		"5af1",
		"chunk-032349eb",
		"chunk-117f2abe"
	],
	"./Withdrawals/ProcessDialog.vue": [
		"9095",
		"chunk-de76af38"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;